import { render, staticRenderFns } from "./Architectural.vue?vue&type=template&id=2dd66504&"
import script from "./Architectural.vue?vue&type=script&lang=js&"
export * from "./Architectural.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports